const baseUrl =
  process.env.REACT_APP_BASE_API_URL ||
  'https://testingweb.bvlabs.com:44392/api/';

const urlBuilder = (endPoint: string = '') => {
  return `${baseUrl}${endPoint}`;
};

export default urlBuilder;
